import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import AdCardMetrics from '../../../../../../features/components/AdCardListItem/AdCardMetrics'
import AdCardMetric from '../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric'

import { formatListItemValues } from '../../../../../../features/formatters'
import { renderMetricValue } from '../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric/renderMetricValue'

import useStyles from '../styles'

const TikTokAdPreviewCardMetrics = ({ ad, currencySymbol, showConversionsMetric, showAdditionalMetrics }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  const formattedData = useMemo(() => formatListItemValues(ad, { symbol: currencySymbol }), [ad, currencySymbol])

  const { impressions, cpm, reach, frequency, clicks, ctr, conversions, spend } = formattedData

  return (
    <AdCardMetrics>
      <AdCardMetric>
        <div>
          {t('Impressions')}
          {showAdditionalMetrics && <span className={classes.metricAdditional}> ({t('CPM')})</span>}
        </div>
        <div>
          {renderMetricValue(impressions)}
          {showAdditionalMetrics && <span className={classes.metricAdditional}> ({renderMetricValue(cpm)})</span>}
        </div>
      </AdCardMetric>
      <AdCardMetric>
        <div>
          {t('Reach')} <span className={classes.metricAdditional}>({t('Frequency')})</span>
        </div>
        <div>
          {renderMetricValue(reach)} <span className={classes.metricAdditional}>({renderMetricValue(frequency)})</span>
        </div>
      </AdCardMetric>
      <AdCardMetric>
        <div>
          {t('Clicks')} <span className={classes.metricAdditional}>({t('CTR')})</span>
        </div>
        <div>
          {renderMetricValue(clicks)} <span className={classes.metricAdditional}>({renderMetricValue(ctr)})</span>
        </div>
      </AdCardMetric>

      {showConversionsMetric && (
        <AdCardMetric>
          <div>{t('Conversions')}</div>
          <div>{renderMetricValue(conversions)}</div>
        </AdCardMetric>
      )}
      {showAdditionalMetrics && (
        <AdCardMetric>
          <div>{t('Spend')}</div>
          <div>{renderMetricValue(spend)}</div>
        </AdCardMetric>
      )}
    </AdCardMetrics>
  )
}

TikTokAdPreviewCardMetrics.propTypes = {
  ad: PropTypes.object.isRequired,
  currencySymbol: PropTypes.string,
  showConversionsMetric: PropTypes.bool,
  showAdditionalMetrics: PropTypes.bool
}

export default TikTokAdPreviewCardMetrics
